// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.min.js';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Home from './pages/Home';
import Aboutus from './pages/Aboutus';
import Solutions from './pages/Solutions';
import Blog from './pages/Blog';
import Media from './pages/Media';
import Contactus from './pages/Contactus';
import Testride from './pages/Testride';

import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';

import './styles/Style.css'
import { Button } from 'react-bootstrap';
import { useState } from 'react';
import BlogDetails from "./pages/BlogDetails";
import StatusPage from "./pages/StatusPage";
import TagManager from "react-gtm-module";

// const gtmId = 'GTM-N8SXG24';
// TagManager.initialize({ gtmId });

const tagManagerArgs = { gtmId: 'GTM-N8SXG24' }
TagManager.initialize(tagManagerArgs)

function App() {
  const[fixtop, setFixTop]=useState(false);

  function setFixedTop(){
    if (window.scrollY >= 200){
      setFixTop(true)
    }else{
      setFixTop(false)
    }
  }

  window.addEventListener("scroll", setFixedTop)

  const top=()=>{
    window.scrollTo(0,0);
  };

  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/aboutus" element={<Aboutus/>}/>
          <Route path="/solutions" element={<Solutions/>}/>
          <Route path="/blog" element={<Blog/>}/>
          <Route path="/blog/:blogDetailsUrl" element={<BlogDetails/>}/>
          <Route path="/media" element={<Media/>}/>
          <Route path="/contactus" element={<Contactus/>}/>
          <Route path="/contactus:cId/:cSource" element={<Contactus/>}/>
          <Route path="/contactus/:status" element={<StatusPage/>}/>
          <Route path="/testride" element={<Testride/>}/>
          <Route path="/testride/:cId/:cSource" element={<Testride/>}/>
          <Route path="/testride/:status" element={<StatusPage/>}/>
          <Route path="/termsconditions" element={<TermsConditions/>}/>
          <Route path="/privacypolicy" element={<PrivacyPolicy/>}/>
          {/* <Route path="/success" element={<SuccessPage/>}/>
          <Route path="/error" element={<ErrorPage/>}/> */}
        </Routes>
      </Router>

      <Button onClick={top} className={fixtop ? 'top-btn' : 'top-btn-none'}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="var(--global--color-white)" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 404 511.5"><path fillRule="nonzero" d="m219.24 72.97.54 438.53h-34.95l-.55-442.88L25.77 241.96 0 218.39 199.73 0 404 222.89l-25.77 23.58z"/></svg>
      </Button>
    </div>

  );
}

export default App;
